var render = function render(){var _vm=this,_c=_vm._self._c;return _c('venue-list',{attrs:{"groupId":_vm.draft.id,"venues":_vm.venues,"editInModal":"","hasMoreVenues":!!_vm.meta.nextId && !!_vm.meta.nextValue},on:{"venueCreated":_vm.onVenueCreated,"loadMore":_vm.loadMoreVenues}})
}
var staticRenderFns = []

export { render, staticRenderFns }